import Base from './base';

import { isRtl } from '../../library/constants';
import { cloneVar } from '../../library/calc';

import './index.css';

class Crop extends Base {


  pageCurrent = 1;
  pageDone = 1;

  renderOnePage(page){

    clearInterval(this.doInterval);
    this.pageCurrent = page;
    const activeSectionXStart = this.eachSegmentWidth * this.pageCurrent;
    this.shiftCanvas({ activeSectionXStart });
    this.assembleTreeInSections({ activeSectionXStart });

  }

  renderCanvasTreeInSections({isPreview}){

    this.showPrintTreeProgressIndicator(true);

    clearInterval(this.doInterval);
    this.pageCurrent = 1;
    this.pageDone = 0;
    let sectionStart = 0;
    let continueToNextSection = true;

    const doEachSection = ({activeSectionXStart}) => {

      this.shiftCanvas({ activeSectionXStart });
      this.assembleTreeInSections({ activeSectionXStart, isPreview });

    }
    this.doInterval = setInterval(() => {
      if ((sectionStart === this.printCanvasWidth) ||
          (this.state.isPreviewRender && this.pageCurrent === this.numPreviewPanels)
      ){
        if( this.state.isPreviewRender ) this.renderButtonEnabled(true);
        this.showPrintTreeProgressIndicator(false);
        clearInterval(this.doInterval);
      }
      if( this.currentSectionCompleted() ){
        this.pageCurrent++;
        continueToNextSection = true;
        sectionStart += this.eachSegmentWidth;
      } else {
        if (sectionStart < this.printCanvasWidth &&
            continueToNextSection
        ){
          continueToNextSection = false;
          const activeSectionXStart = cloneVar(sectionStart);
          doEachSection({ activeSectionXStart});
        };
      }
    }, 200);


  }

  currentSectionCompleted(){
    return this.pageDone === this.pageCurrent
  }

  renderCanvasToImg(){
    // document.getElementById('imgCanvasContainer').src = null;
    document.getElementById('imgCanvasContainer').src = '';
    const dataURL = this.printStage.current.toDataURL();
    if( document.getElementById('imgCanvasContainer')) {
      document.getElementById('imgCanvasContainer').onload = () => {
        this.pageDone++;
        if(this.inProcess) this.cropImgForEachSections();
      };
      document.getElementById('imgCanvasContainer').src = dataURL;
    }

  }

  shiftCanvas({ activeSectionXStart }){

    if( this.verySmallTree ){
      this.printStage.current.position({
        x: (activeSectionXStart + (this.differencePrintCanvasWidth / 2)),
        y: (this.differencePrintCanvasHeight / 2) / this.portion,
      });
    } else {
      this.printStage.current.position({
        x: -1 * (activeSectionXStart),
        y: 0,
      });
    }

    this.printStage.current.batchDraw();

  }

  setCroppedWidthHeight(){
    this.cropWidth = this.printCanvasWidth / (this.state.page);
    this.cropHeight = (this.reducedCanvasTreeBy * this.pageHeight) / this.state.page;
    this.widthHeightRatio = this.cropWidth / this.cropHeight;
    this.imgWidth = (this.printCanvasWidth / this.reducedCanvasTreeBy) / this.state.page;
    this.imgHeight = this.pageHeight / this.portion;
    this.pdfImgHeight =  this.imgWidth/ this.pdFLandscapeRatio;
    this.pdfPadding = this.pdfImgHeight - this.imgHeight;
  }


  imgBorderWidth = 1;
  setCroppedContainerWrapperWidth({isPreview}){
    const widthContainer =  `${(this.printCanvasWidth / this.reducedCanvasTreeBy) - (this.state.page * this.imgBorderWidth)}px`
    if( !this.isPrintFlipCardMobile && document.getElementById('croppedContainer') ) document.getElementById('croppedContainer').style.width  = widthContainer;
    if( document.getElementById('croppedGhostContainer') ) document.getElementById('croppedGhostContainer').style.width  = widthContainer;
    if( !this.isPrintFlipCardMobile && document.getElementById('croppedContainer') && isPreview && isRtl){
      document.getElementById('croppedContainer').style.setProperty("width", "100%", "important");
      document.getElementById('croppedContainer').style.setProperty("left", "2%", "important");
      document.getElementById('croppedContainer').classList.add("preview");
      document.getElementById('croppedGhostContainer').classList.add("preview");
      document.getElementById('croppedGhostContainer').style.setProperty("width", "101%", "important");
    }
    if( !this.isPrintFlipCardMobile && document.getElementById('croppedContainer') && !isPreview && isRtl){
      document.getElementById('croppedContainer').classList.remove("preview");
      document.getElementById('croppedContainer').style.setProperty("left", "0px", "important");
      document.getElementById('croppedGhostContainer').classList.remove("preview");
      document.getElementById('croppedContainer').style.setProperty("width", widthContainer, "important");
      document.getElementById('croppedGhostContainer').style.setProperty("width", widthContainer, "important");
    }
  }

  setCroppedContainerWrapperHeightPadding(){
    this.halfPDFPadding = (this.pdfPadding / 2);
    this.scaleContainer = this.imgHeight / this.pdfImgHeight;
    this.scaleContainer = this.scaleContainer * .80  // printTreeResolution Tweak

    if( document.getElementById('croppedContainerWrapper') ){

      document.getElementById('croppedContainerWrapper').style.height  = `${this.pdfImgHeight + 100}px`;  // printTreeResolution Tweak

      // document.getElementById('croppedContainerWrapper').style.top  = `${-1 * this.halfPDFPadding - 70}px`;
      document.getElementById('croppedContainerWrapper').style.top  = `${-1 * this.halfPDFPadding -  ( this.lowerPrintRes ? 150: 70) }px`; // printTreeResolution SuperTweak old: 70

      document.getElementById('croppedContainerWrapper').style.width  = `${ 100 / this.scaleContainer }%`;

      document.getElementById('croppedContainerWrapper').style.left  = `${-1 *  ((50) / this.scaleContainer)}%`;

      document.getElementById('croppedContainer').style.top  = `${this.halfPDFPadding}px`;
      document.getElementById('croppedContainer').style.bottom  = `${this.halfPDFPadding}px`;
      document.getElementById('croppedGhostContainer').style.top  = `${0}px`; // printTreeResolution Tweak `${this.halfPDFPadding}px`;
      document.getElementById('croppedGhostContainer').style.bottom  = `${this.halfPDFPadding}px`;


      document.getElementById('croppedContainerWrapper').style.transform = `scale(${this.scaleContainer})`;

    }
  }

  removeCroppedImgs(){
    const croppedContainer = document.getElementById('croppedContainer');
    while( croppedContainer && croppedContainer.childElementCount > 0){
      croppedContainer.removeChild(croppedContainer.lastElementChild);
    }
    const croppedGhostContainer = document.getElementById('croppedGhostContainer');
    while( croppedGhostContainer && croppedGhostContainer.childElementCount > 0){
      croppedGhostContainer.removeChild(croppedGhostContainer.lastElementChild);
    }
  }

  cropImgForEachSections(){

    const img = document.getElementById('imgCanvasContainer');

    const cropWidth = this.cropWidth - this.imgBorderWidth + this.lastFurthestRightNodeBorderWidth;
    let cropHeight = this.cropHeight * (this.state.page / this.portion);

    const maxCropHeight = cropWidth / this.pdFLandscapeRatio;

    cropHeight = ( cropHeight > maxCropHeight ? maxCropHeight : cropHeight)

    let croppedDataURL = this.cropPlusExport({
      img,
      cropX: 0,
      cropY: 0,
      cropWidth,
      cropHeight,
    });

    var imgCrop = new Image();
    imgCrop.id = `singleCroppedImg-${this.pageCurrent}`;
    imgCrop.width = this.imgWidth - this.imgBorderWidth;
    if( !this.isPrintFlipCardMobile && this.pageCurrent !== this.state.page && isRtl){
      imgCrop.width = this.imgWidth - 5;
    }
    imgCrop.height = this.imgHeight;
    imgCrop.style.top = `${this.imgHeight/5}px` ; // printTreeResolution Tweak
    if(document.getElementById('croppedContainer')) document.getElementById('croppedContainer').appendChild(imgCrop);


    var imgGhost = new Image();
    // imgGhost.width = (this.imgWidth) - this.imgBorderWidth;
    imgGhost.width = (this.imgWidth * .90) - this.imgBorderWidth; // printTreeResolution Tweak
    if( !this.isPrintFlipCardMobile && this.pageCurrent !== this.state.page && isRtl){
      imgGhost.width = this.imgWidth - 5;
    }
    imgGhost.height = this.imgHeight * 4;
    imgGhost.style.top = '0px' ; // printTreeResolution Tweak `-${this.imgHeight}px` ;
    if( !this.isPrintFlipCardMobile && this.pageCurrent !== this.state.page && !isRtl) imgGhost.style['border-right'] =  `${this.imgBorderWidth - (this.imgBorderWidth * this.scaleContainer)}px dotted lightgray`;
    if( !this.isPrintFlipCardMobile && this.pageCurrent !== this.state.page && isRtl) imgGhost.style['border-left'] =  `${this.imgBorderWidth - (this.imgBorderWidth * this.scaleContainer)}px solid lightgray`;
    if(document.getElementById('croppedGhostContainer')) document.getElementById('croppedGhostContainer').appendChild(imgGhost)

    const elCroppedSection = document.getElementById(`singleCroppedImg-${this.pageCurrent}`);
    elCroppedSection.src = croppedDataURL;
    elCroppedSection.className += " singleCroppedImgs";

    elCroppedSection.onload = () => {
    };

    if( !this.state.isPreviewRender){
      this.buildPDFContentArray({croppedDataURL, pageCurrent: this.pageCurrent});
    }

    this.showRenderLabel();

    if( parseInt( this.pageCurrent , 10) === parseInt( this.state.page , 10)){
      if( !this.state.isPreviewRender){
        this.renderComplete()
      }
    } else {
    }

    setTimeout(() => {
      this.scrollCroppedContainer();
    }, 700);  // printTreeResolution SuperTweak

  }

  cropPlusExport({img, cropX, cropY, cropWidth, cropHeight}){
    var croppedCanvas = document.createElement('canvas');
    croppedCanvas.width = cropWidth;
    croppedCanvas.height = cropHeight;  // printTreeResolution Tweak
    var ctx = croppedCanvas.getContext('2d');
    ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

    if( this.state.bw ){
      var imgPixels = ctx.getImageData(0, 0, cropWidth, cropHeight);
      for(var y = 0; y < imgPixels.height; y++){
       for(var x = 0; x < imgPixels.width; x++){
            var i = (y * 4) * imgPixels.width + x * 4;
            var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
            imgPixels.data[i] = avg;
            imgPixels.data[i + 1] = avg;
            imgPixels.data[i + 2] = avg;
       }
      }
      ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
    }

    return(croppedCanvas.toDataURL());
  }

}

export default Crop;

